import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    // the translations
    // (tip move them in a JSON file and import them,
    // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
    resources: {
      en: {
        translation: {
          'login.title': 'Sign In',
          'page.stores': 'Stores',
          'page.dailyReports': 'Daily Reports',
          'page.Reports': 'Reports',
          'page.users': 'Users',
          'page.dayReports': 'Day Reports',
          'page.dayReportDetails': 'Day Report',
          'page.userDetails': 'User Details',
          'page.storeDetails': 'Store Details',
          'page.addNewUser': 'Add User',
          'page.addNewStore': 'Add Store',
          'page.dashboard': 'Dashboard',
          'page.changePassword': 'Change Password',
          'page.royaltyReports': 'Franchisee Fee Reports',
          'page.dayReportStatus': 'Day Report Status',
          'page.achFormResponses': 'Form Responses',

          'nav.dashboard': 'Dashboard',
          'nav.orders': 'Orders',
          'nav.products': 'Products',
          'nav.customers': 'Customers',
          'nav.users': 'Users',
          'nav.reports': 'Reports',
          'nav.stores': 'Stores',
          'nav.analytics': 'Analytics',
          'nav.discount': 'Discount',
          'nav.inventory': 'Inventory',
          'nav.logout': 'Logout',
          'nav.login': 'Login',
          'nav.summary': 'Summary',
          'nav.royalty': 'Franchisee Fee',
          'nav.dayReportStatus': 'Day Report Status',
          'nav.achFormResponses': 'Form Responses',
          'nav.royaltyReports': 'Franchisee Fee Reports',

          'dayReport.sales.taxableLiquorSales': 'Sales Taxable Liquor',
          'dayReport.sales.taxableOthers': 'Sales Taxable Others',
          'dayReport.sales.taxable': 'Sales - Taxable',
          'dayReport.sales.nonTaxSales': 'Sales - Non-Taxable',
          'dayReport.sales.otherFood': 'Sales - Other - Food',
          'dayReport.sales.netTotalSales': 'Total sales',
          'dayReport.sales.salesTaxCollected': 'Sales tax collected',
          'dayReport.sales.crvTaxable': 'CRV - Taxable',
          'dayReport.sales.crvNonTaxable': 'CRV - Non-Taxable',
          'dayReport.sales.ckCashingComm': 'Ck Cashing Comm.',
          'dayReport.sales.lottery': 'Lottery sales',
          'dayReport.sales.lotto': 'Lotto sales',
          'dayReport.sales.returnedCheck': 'Returned Check Collected',
          'dayReport.sales.rebates': 'Rebates',
          'dayReport.sales.salesECigarette': 'Sales - E Cigarettes',
          'dayReport.sales.cecetTaxCollected': 'CECET Tax Collected',
          'dayReport.sales.totalCashRecv': 'Total Cash Received',
          'dayReport.sales.totalCahRecv': 'Total cash rec. (4 to 16)',
          'dayReport.sales.lessCashPaid': 'Less cash paid out (line 55)',
          'dayReport.sales.netCashRecv': 'Net Taxable Sales',
          'dayReport.sales.totalSalesTaxCollected': 'Total Tax Collected',
          'dayReport.sales.combinedCecetTaxCollected': 'Combined CECET Tax',

          'dayReport.cashPO.lotteryWinningsPaid': 'Lottery Winnings Paid',
          'dayReport.cashPO.lottoWinningsPaid': 'Lotto Winnings Paid',
          'dayReport.cashPO.debitCards': 'Debit Cards',
          'dayReport.cashPO.creditCards': 'Credit Cards',
          'dayReport.cashPO.ebt': 'EBT',
          'dayReport.cashPO.purchGroceryNonTaxable': 'Purch., grocery, nontaxable',
          'dayReport.cashPO.purchGroceryTaxable': 'Purch., grocery, taxable',
          'dayReport.cashPO.purchFoodService': 'Purch. - Food Service',
          'dayReport.cashPO.purchOthers': 'Purch. Others',
          'dayReport.cashPO.storeSupplies': 'Store Supplies',
          'dayReport.cashPO.garbage': 'Garbage',
          'dayReport.cashPO.repairsJanitorial': 'Repairs, janitorial',
          'dayReport.cashPO.storeCoupons': 'Store Coupons',
          'dayReport.cashPO.couponsCharges': 'Coupons & charges',
          'dayReport.cashPO.gasAndOil': 'Gas & oil',
          'dayReport.cashPO.employeePurchase': 'Employee Purchases',
          'dayReport.cashPO.gasNegativeDeposit': 'Gas Negative Deposit',
          'dayReport.cashPO.totalCashPO': 'Total Paid Out',

          'dayReport.cashPO.hint.lotteryWinningsPaid': 'Lottery Winnings Paid',
          'dayReport.cashPO.hint.lottoWinningsPaid': 'Lotto Winnings Paid',
          'dayReport.cashPO.hint.debitCards': 'Debit Cards',
          'dayReport.cashPO.hint.creditCards': 'Credit Cards',
          'dayReport.cashPO.hint.ebt': 'EBT',
          'dayReport.cashPO.hint.purchGroceryNonTaxable': 'Purch., grocery, nontaxable',
          'dayReport.cashPO.hint.purchGroceryTaxable': 'Purch., grocery, taxable',
          'dayReport.cashPO.hint.purchFoodService': 'Purch. - Food Service',
          'dayReport.cashPO.hint.purchOthers': 'Purch. Others',
          'dayReport.cashPO.hint.storeSupplies': 'Store Supplies',
          'dayReport.cashPO.hint.garbage': 'Garbage',
          'dayReport.cashPO.hint.repairsJanitorial': 'Repairs, janitorial',
          'dayReport.cashPO.hint.storeCoupons': 'Store Coupons',
          'dayReport.cashPO.hint.couponsCharges': 'Coupons & charges',
          'dayReport.cashPO.hint.gasAndOil': 'Gas & oil',
          'dayReport.cashPO.hint.employeePurchase': 'Employee Purchases',
          'dayReport.cashPO.hint.gasNegativeDeposit': 'Gas Negative Deposit',
          'dayReport.cashPO.hint.totalCashPO': 'Total Paid Out',

          'dayReport.cashDeposit.depositCkCashing': 'Deposit, Ck Cashing',
          'dayReport.cashDeposit.depositSales': 'Deposit - Sales',
          'dayReport.cashDeposit.deposit': 'Deposit',
          'dayReport.cashDeposit.endingCashBal': 'Ending cash balance',
          'dayReport.cashDeposit.beginingCashBal': 'Beginning cash balance',
          'dayReport.cashDeposit.totalDeposit': 'Subtotal',
          'dayReport.cashDeposit.cashOver': 'Cash over (short)  Line 25 minus 26',

          'dayReport.cashDeposit.hint.depositCkCashing': 'Deposit, Ck Cashing',
          'dayReport.cashDeposit.hint.depositSales': 'Deposit - Sales',
          'dayReport.cashDeposit.hint.deposit': 'Deposit',
          'dayReport.cashDeposit.hint.endingCashBal': 'Ending cash balance',
          'dayReport.cashDeposit.hint.beginingCashBal': 'Beginning cash balance',
          'dayReport.cashDeposit.hint.totalDeposit': 'Subtotal',
          'dayReport.cashDeposit.hint.cashOver': 'Cash over (short)  Line 25 minus 26',

          'dayReport.summary.totalCashReceived': 'Total cash rec.',
          'dayReport.summary.totalCashPO': 'Less cash paid out',
          'dayReport.summary.totalCashOver': 'Cash over (short)',
          'dayReport.summary.totalCashDeposit': 'Total Cash Deposit',
          'dayReport.summary.netCashReceived': 'Net cash rec.',

          'dayReport.voids.txnNo': 'Transaction Number',
          'dayReport.voids.txnNo.hint': 'Enter Transaction Number',
          'dayReport.voids.amount': 'Amount',
          'dayReport.voids.amount.hint': 'Enter Amount',

          'gasReport.sales.regularGallons': 'Gallons - Regular',
          'gasReport.sales.regularSales': 'Sales - Regular',
          'gasReport.sales.regularVoids': 'Less Voids & Refund',
          'gasReport.sales.regularNetSales': 'Net Regular Sales',

          'gasReport.sales.plusGallons': 'Gallons - Plus',
          'gasReport.sales.plusSales': 'Sales - Plus',
          'gasReport.sales.plusVoids': 'Less Voids & Refund',
          'gasReport.sales.plusNetSales': 'Net Plus Sales',

          'gasReport.sales.premiumGallons': 'Gallons - Premium',
          'gasReport.sales.premiumSales': 'Sales - Premium',
          'gasReport.sales.premiumVoids': 'Less Voids & Refund',
          'gasReport.sales.premiumNetSales': 'Net Premium Sales',

          'gasReport.sales.dieselGallons': 'Gallons - Diesel',
          'gasReport.sales.dieselSales': 'Sales - Diesel',
          'gasReport.sales.dieselVoids': 'Less Voids & Refund',
          'gasReport.sales.dieselNetSales': 'Net Diesel Sales',

          'gasReport.sales.paidOuts': 'Paid-outs',
          'gasReport.sales.discounts': 'Fuel Discounts',

          'gasReport.sales.totalSalesGas': 'Total Gas Sales',
          'gasReport.sales.stateTaxGas': 'State Tax (Gas)',
          'gasReport.sales.distTaxGas': 'District Tax (Gas)',
          'gasReport.sales.totalSalesWithoutTaxGas': 'Total Gas Sales without Tax',

          'gasReport.sales.totalSalesDsl': 'Total Diesel Sales',
          'gasReport.sales.stateTaxDsl': 'State Tax (Diesel)',
          'gasReport.sales.distTaxDsl': 'District Tax (Diesel)',
          'gasReport.sales.totalSalesWithoutTaxDsl': 'Total Diesel Sales without Tax',

          'gasReport.sales.totalSales': 'Total Sales (Gas + Diesel) w/tax',
          'gasReport.sales.totalSalesWithoutTax': 'Total Sales (Gas + Diesel) w/o tax',

          'gasReport.sales.salesCCVisaMC': 'Credit - Visa/MC',
          'gasReport.sales.salesCCOther': 'Credit - Others',
          'gasReport.sales.salesDC': 'Debit',
          'gasReport.sales.salesOther': 'Others',
          'gasReport.sales.totalCCSales': 'Total Cr Card Sales',
          'gasReport.sales.netGasDeposit': 'Net Gas Deposit',

          'gasReport.sales.totalTaxGas': 'Total Gas Tax',
          'gasReport.sales.totalTaxDsl': 'Total Diesel Tax',
          'gasReport.sales.blank': '',

          'error.blankUsername': 'Please enter Username',
          'error.blankPwd': 'Please enter password',
          'error.invalidUserNamePwd': 'Invalid username or password.',
          'error.loadStores': 'Could not load stores.',
          'error.loadDayReports': 'Could not load reports.',
          'error.loadRoles': 'Could not load user roles.',
          'error.couldNotUpdate': 'Could not update the data.',
          'error.loadACHFormResponses': 'Could not load form responses.',
          'error.loadReports': 'Could not load reports.',
          'error.approveReport': 'Error in approving the report. Please try again.',

          'dashboard.dayReport': 'Daily Sales',
          'dashboard.gasReport': 'Gas Gales',
          'dashboard.summarySales': 'Summary',
          quickAnalysis: 'Quick Analysis',

          'success.updated': 'Successfully updated!',
          'success.approved': 'Successfully approved!',

          'storeType.text.WITH_GAS_STATION': 'With Gas Station',
          'storeType.text.WITHOUT_GAS_STATION': 'Without Gas Station',

          //default ones
          admin: 'admin',
          dashboard: 'Dashboard',
          orders: 'Orders',
          products: 'Products',
          customers: 'Customers',
          analytics: 'Analytics',
          discount: 'Discount',
          inventory: 'Inventory',
          logout: 'Logout',
          login: 'Sign In',
          summary: 'Summary',
          orderID: 'Order ID',
          totalPrice: 'Total Price',
          date: 'Date',
          status: 'Status',
          approved: 'Approved',
          pending: 'Pending',
          rejected: 'Rejected',
          viewAll: 'View All',
          search: 'Search',
          contacts: 'Contacts',
          edit: 'Edit',
          userName: 'User Name',
          pass: 'Password',
          phoneNumber: 'Phone Number',
          email: 'Email',
          address: 'Address',
          upload: 'Upload',
          location: 'Location',
          deleteCustomer: 'Delete Customer',
          modalMessage: 'Are you sure about delete this?',
          delete: 'Delete',
          cancel: 'Cancel',
          actions: 'Actions',
          category: 'Category',
          all: 'All',
          clothing: 'Clothing',
          digital: 'Digital',
          beauty: 'Beauty',
          product: 'Product',
          price: 'Price',
          proName: 'Product Name',
          inventoryCount: 'Inventory Count',
          loginPage: 'Login Into Your Account',
          forgetPass: 'Forget your password?',
          rememberMe: 'Remember me',
          salesAmount: '5,340',
          orderAmount: '3000',
          revenueAmount: '2,500',
          currency: '$',
          summaryOfSale: 'Chart Of Sale',
          summaryOfRevenue: 'Chart Of Revenue',
          summaryOfOrders: 'Chart Of Order',
          Jan: 'Jan',
          Feb: 'Feb',
          Mar: 'Mar',
          Apr: 'Apr',
          May: 'May',
          Jun: 'Jun',
          July: 'July',
          Aug: 'Aug',
          Sep: 'Sep',
          Oct: 'Oct',
          Nov: 'Nov',
          Dec: 'Dec',
          backToHome: 'Back to Main Page',
          notFoundMsg: 'Page Not Found!',
        },
      },
      fa: {
        translation: {},
      },
    },
    lng: 'en', // if you're using a language detector, do not define the lng option
    fallbackLng: 'en',

    interpolation: {
      escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
  });

export default i18n;
